import moment from 'moment-timezone';
import numeral from 'numeral';
import { formatCpDate, CPDate } from '@cp-shared-19/common-utilities';

import 'moment/locale/es';
import { registerNumeralMx } from './local/es-mx';

// Check out https://momentjs.com/timezone/
export const MX_TIMEZONE = 'America/Mexico_City';

moment.tz.setDefault(MX_TIMEZONE);

export const DATE_FORMAT = 'DD/MM/YYYY';

const locale = 'es';
const numeralLocale = 'es-mx';
export const numberFormat = '0,0';
export const numberFormatRoundedOne = '0,0.0';
const numeralFormat = '0o';
const currencyFormat = '0,0.00';
const longDateFormat = 'DD/MMM/YYYY';

export function changeLocale(locale: 'en' | 'es'): void {
    moment.locale(locale);
    numeral.locale(numeralLocale);
}
registerNumeralMx();
changeLocale(locale);

export function formatAsCurrency(value?: number): string {
    return typeof value === 'number' ? `$${numeral(value).format(currencyFormat)}` : '';
}

export function formatAsDate(date?: CPDate, upper = true, digit = false): string {
    if (upper) {
        let formatDate = date ? formatCpDate(date).format(digit ? DATE_FORMAT : longDateFormat) : '';
        formatDate = formatDate.replace('.', '');
        formatDate = formatDate.replace(formatDate.charAt(3), formatDate.charAt(3).toUpperCase());
        return formatDate;
    }
    return date ? formatCpDate(date).format(digit ? DATE_FORMAT : longDateFormat) : '';
}
export function formatAsNumber(value?: number, format: string = numberFormat): string {
    return typeof value === 'number' ? numeral(value).format(format) : '';
}

export function formatAsNumeral(value?: number): string {
    return typeof value === 'number' ? numeral(value).format(numeralFormat) : '';
}

export function formatAsDistance(value?: number): string {
    return typeof value === 'number' ? numeral(value).format(numberFormat) : '';
}

export function formatAsEmission(value?: number): string {
    return typeof value === 'number' ? `${numeral(value).format(numberFormat)} g/km` : '';
}

export function formatAsIban(iban?: string): string {
    return (
        iban
            ?.replace(/[^\dA-Z]/g, '')
            .replace(/(.{4})/g, '$1 ')
            .trim() ?? ''
    );
}
